import React, { useState, useEffect, useRef } from 'react'
// import PropTypes from 'prop-types';
import './circleButton.css'
// var disabled = false
export default ({ onClick }) => {
    const [disabledState, setDisabledState] = useState(false)
    const disabled = useRef(false)
    // weird way to get rerender before the click function so IE flash cam doesnt lock the screen
    // before button goes red
    useEffect(() => {
        // weird because of above comment
        let i = -1
        if (disabledState)
            i = setTimeout(() => {
                onClick()
            }, 100)
        if (i !== -1) return () => clearTimeout(i)
    }, [disabledState])

    // let innerCircleClasses = isClicked ? 'is-clicked' : '';
    let innerCircleClasses = disabled.current ? 'disabled' : ''
    return (
        <div id="container-circles">
            <div
                id="outer-circle"
                onClick={(e) => {
                    if (disabled.current) return
                    disabled.current = true
                    setDisabledState(true)
                    setTimeout(() => {
                        setDisabledState(false)
                        disabled.current = false
                    }, 1000)
                }}
            >
                <div id="inner-circle" className={disabledState ? 'disabled' : ''}></div>
            </div>
        </div>
    )
}

// CircleButton.propTypes = {
//   onClick: PropTypes.func.isRequired,
//   isClicked: PropTypes.bool.isRequired
// };
